var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from "react";
import { Box, Card, Radio, Typography, Button, CardContent } from "@mui/material";
import RadomPaymentDialog from "./radom-payment-dialog";
import RadomPaymentMethodIcon from "./radom-payment-method-icon";
import { enqueueSnackbar } from "notistack";
import { getErrorMessage } from "../../../../utilities/axios-utility";
import { errorSnackbar } from "../../../../shared/snackbar-constants";
import { formatDecimal } from "../../../../utilities/formatNumber";
import { getPaymentMaymentMethodIcon } from "./radom-payment-configs";
var RadomProcessorPage = function (_a) {
    var paymentSessionId = _a.paymentSessionId, geoData = _a.geoData, setPaymentResult = _a.setPaymentResult, setPaymentResultOpened = _a.setPaymentResultOpened, setPaymentInProgress = _a.setPaymentInProgress, api = _a.api, totalAmount = _a.totalAmount, radomPaySetting = _a.radomPaySetting;
    var processorCommonCode = "RADM";
    var _b = useState(), selectedMethod = _b[0], setSelectedMethod = _b[1];
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(), paymentData = _e[0], setPaymentData = _e[1];
    var intervalRef = useRef(null);
    var showPaymentResult = function (data) {
        setOpen(false);
        setPaymentResultOpened(true);
        if (data)
            setPaymentResult(data);
        setPaymentInProgress(false);
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
    };
    var checkPaymentStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, code, data, description, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.CheckPaymentStatus(paymentSessionId)];
                case 1:
                    result = _a.sent();
                    code = result.code, data = result.data, description = result.description;
                    if (code === 200000) {
                        if (data.detail.state !== "PENDING") {
                            showPaymentResult(data);
                        }
                    }
                    else {
                        enqueueSnackbar(description, errorSnackbar);
                        showPaymentResult(data);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    enqueueSnackbar(getErrorMessage(error_1), errorSnackbar);
                    showPaymentResult(null);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handlePaymentDialogClose = function () {
        setOpen(false);
    };
    var handleContinue = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, result, code, data, description, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setOpen(true);
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    request = {
                        processorCommonCode: processorCommonCode,
                        paymentSessionId: paymentSessionId,
                        asset: selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.Asset,
                        network: selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.Network,
                    };
                    return [4 /*yield*/, api.OpenPayment(request)];
                case 2:
                    result = _a.sent();
                    code = result.code, data = result.data, description = result.description;
                    if (data.detail.additionalData) {
                        setPaymentData(data.detail.additionalData);
                        intervalRef.current = setInterval(checkPaymentStatus, 30 * 1000);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    enqueueSnackbar(getErrorMessage(error_2), errorSnackbar);
                    setOpen(false);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleExpired = function () {
        // if (intervalRef.current) {
        //     clearInterval(intervalRef.current);
        // }
        checkPaymentStatus();
    };
    useEffect(function () {
        if (radomPaySetting.length > 0)
            setSelectedMethod(radomPaySetting[0]);
    }, []);
    return (_jsxs(Box, __assign({ width: 400 }, { children: [_jsx(Box, __assign({ my: 1 }, { children: _jsx(Typography, __assign({ variant: "body2", gutterBottom: true }, { children: "Payment method" })) })), radomPaySetting.map(function (option) { return (_jsx(Card, __assign({ variant: "outlined", sx: {
                    mb: 1,
                    opacity: 1,
                    borderColor: (selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.TokenAddress) === option.TokenAddress ? "primary.main" : "grey.300",
                    cursor: "pointer",
                }, onClick: function () { return setSelectedMethod(option); } }, { children: _jsx(CardContent, __assign({ sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    } }, { children: _jsxs(Box, __assign({ display: "flex", alignItems: "center" }, { children: [_jsx(Radio, { checked: (selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.TokenAddress) === option.TokenAddress, sx: { mr: 1 } }), _jsx(RadomPaymentMethodIcon, { mainIcon: getPaymentMaymentMethodIcon(option.Asset), networkIcon: getPaymentMaymentMethodIcon(option.Network) }), _jsxs(Box, __assign({ ml: 2 }, { children: [_jsx(Typography, __assign({ fontWeight: "bold" }, { children: formatDecimal(totalAmount) })), _jsxs(Typography, __assign({ sx: { display: "flex", alignItems: "center" }, component: "div" }, { children: [_jsx(Typography, __assign({ sx: { color: "#999999" }, component: "span" }, { children: option.Asset })), _jsx(Box, __assign({ component: "span", mx: 0.5 }, { children: "on" })), _jsx(Typography, __assign({ component: "span" }, { children: option.Network }))] }))] }))] })) })) }), option.TokenAddress)); }), _jsx(Button, __assign({ variant: "contained", color: "success", fullWidth: true, sx: { mt: 2, borderRadius: "24px", py: 1.2 }, disabled: !selectedMethod, onClick: function () { return handleContinue(); } }, { children: "Continue" })), selectedMethod && (_jsx(RadomPaymentDialog, { opened: open, loading: loading, asset: selectedMethod.Asset, paymentData: paymentData, onExpired: handleExpired, onClose: handlePaymentDialogClose }))] })));
};
export default RadomProcessorPage;
